// Static conversation starters surfaced as quick-tap chips above the chat
// input. Hand-curated to be playful but safe.
export const CONVERSATION_STARTERS = [
  "Hey, your bio made me smile — what's the story behind it?",
  "What's the most fun thing you've done this month?",
  "If we were having drinks right now, what would you order?",
  "Three places on your bucket list — go!",
  "What's a song that always gets you in a good mood?",
  "Coffee or cocktail for a first date?",
  "What's something underrated about your city?",
  "What are you really good at that surprises people?",
  "Worst pickup line you've ever received? I'll go first.",
  "What's your weekend vibe — chill or chaotic?",
  "If you had a free afternoon tomorrow, how would you spend it?",
  "What's a movie you can rewatch endlessly?",
  "Sunrise or sunset person?",
  "What's the best meal you've had this week?",
  "Tell me a fun fact about yourself nobody else knows.",
  "Beach, mountains, or city for an ideal trip?",
  "What's currently on your nightstand?",
  "What's making you laugh lately?",
  "If your week had a soundtrack, what would the opening song be?",
  "Pineapple on pizza — yes or absolutely not?",
];

// Report reasons (must mirror /app/backend/routes/safety.py ALLOWED_REASONS)
export const REPORT_REASONS = [
  { value: "fake_profile", label: "Fake or stolen profile" },
  { value: "inappropriate_photos", label: "Inappropriate photos" },
  { value: "harassment", label: "Harassment or abuse" },
  { value: "spam_or_scam", label: "Spam or scam" },
  { value: "underage", label: "Looks underage" },
  { value: "other", label: "Other" },
];
